import { useEffect, useMemo } from 'react'
import { http } from '@/lib'
import UserOperationStatus from '@/utils/user-operation-status'
import { useAsyncFn, useEffectOnce, useLocalStorage } from '@clara/hooks'
import { GETTING_STARTED_LOCALSTORAGE_KEY } from '@/utils/constants'

type Operation = 'ENABLED' | 'DISABLED'

export function useUserOperationStatus(key: UserOperationStatus) {
  const [showGettingStarted, setShowGettingStarted] = useLocalStorage(
    GETTING_STARTED_LOCALSTORAGE_KEY,
    'visible',
  )
  const [getUserOperationStatusResponse, getUserOperationStatus] = useAsyncFn(
    async () =>
      await http
        .get<{
          identifier: string
          operationStatus: Operation
        }>('/user-operation-status/' + key)
        .then((response) => response.data),
    [],
  )

  const [postUserOperationStatusResponse, postUserOperationStatus] = useAsyncFn(
    async () =>
      await http
        .post('/user-operation-status', {
          identifier: key,
          operationStatus: 'ENABLED',
        })
        .then((response) => response.data),
    [],
  )

  useEffectOnce(() => {
    if (showGettingStarted === 'visible') {
      getUserOperationStatus()
    }
  })

  useEffect(() => {
    if (getUserOperationStatusResponse.value?.operationStatus === 'ENABLED') {
      setShowGettingStarted('hidden')
    }
  }, [
    getUserOperationStatusResponse.value?.operationStatus,
    setShowGettingStarted,
  ])

  useEffect(() => {
    if (postUserOperationStatusResponse.value) {
      getUserOperationStatus()
    }
  }, [getUserOperationStatus, postUserOperationStatusResponse.value])

  const userClickedStartToUseButton = useMemo(
    () =>
      (!getUserOperationStatusResponse.error &&
        getUserOperationStatusResponse.value?.operationStatus === 'ENABLED') ||
      showGettingStarted === 'hidden',
    [getUserOperationStatusResponse, showGettingStarted],
  )

  return {
    getUserOperationStatus,
    getUserOperationStatusResponse,
    postUserOperationStatus,
    postUserOperationStatusResponse,
    userClickedStartToUseButton,
  }
}
